module.exports = __webpack_public_path__ + "static/about_me-e09177f43d553bd9a650c6e5e1759dad.jpg";